import {
  fetchYieldProducts,
  getAssetsSituational,
  getWalletInfo,
  DATA_CACHES_KEYS,
} from "@aspen/services/index";
import { updateAssetsLineData, updateWalletInfo, useAppDispatch } from "@aspen/store";
import type { ICommonCacheKeys } from "@aspen/model";
import { COMMON_CACHE_PRIORTY_KEYS } from "@aspen/model";
import { isClient } from "@aspen/libs";
import localforage from "localforage";

/**
 * @param key 唯一key名称
 * @param params 请求参数
 */

function useFecthers(key: ICommonCacheKeys, params: any, cacheKey?: string) {
  if (!key) return;
  const dispatch = useAppDispatch();

  const updateBeforeRequest = (updateFun: Function) => {
    if (isClient && cacheKey) {
      localforage.getItem(cacheKey).then((cacheData: any) => {
        const _cacheResDataKey = DATA_CACHES_KEYS[key].cacheResDataKey;
        try {
          if (_cacheResDataKey) {
            cacheData?.[_cacheResDataKey] && dispatch(updateFun(cacheData?.[_cacheResDataKey]));
          } else {
            dispatch(updateFun(cacheData));
          }
        } catch (error) {
          // ignore
        }
      });
    }
  };

  const fetcherWalletInfo = () => {
    updateBeforeRequest(updateWalletInfo);
    const param = DATA_CACHES_KEYS[key].param;
    return getWalletInfo(param).then(res => {
      if (res?.code == "0") {
        dispatch(updateWalletInfo(res?.data));
        return res?.data;
      }
    });
  };

  const fecherAssetsSituational = () => {
    updateBeforeRequest(updateAssetsLineData);
    return getAssetsSituational(DATA_CACHES_KEYS[key].param).then(res => {
      if (res?.code == "0") {
        dispatch(updateAssetsLineData(res?.data));
        return res?.data;
      }
    });
  };

  const fecherYieldFlexibleProducts = () => {
    return fetchYieldProducts(DATA_CACHES_KEYS[key].param).then(res => {
      if (res?.code == "0") {
        return res?.data?.financingProducts;
      }
    });
  };
  let fetcher;
  switch (key) {
    case COMMON_CACHE_PRIORTY_KEYS.walletInfo:
      fetcher = fetcherWalletInfo;
      break;
    case COMMON_CACHE_PRIORTY_KEYS.assetsLineData:
      fetcher = fecherAssetsSituational;
      break;
    case COMMON_CACHE_PRIORTY_KEYS.yieldFlexibleProducts:
      fetcher = fecherYieldFlexibleProducts;
      break;
    default:
  }
  return fetcher;
}

export { useFecthers };
